import type { InterventionLite } from "@/entities/intervention";
import type { UsersSelectOptionItem } from "@/modules/users/users-select";

import { useInterventionsBatchAssign } from "@/entities/interventions";
import { useBatchEditForm } from "@/modules/batch-edit-form";
import { getUsersSelectOptionItem } from "@/modules/users/users-select";

const fieldName = "users";

export const useInterventionsBatchEditUsers = (
  interventions: InterventionLite[]
) => {
  const initialValue = (interventions[0]?.[fieldName] ?? []).map(
    getUsersSelectOptionItem
  );

  const ids = interventions.map(({ id }) => id);
  const { mutate, isPending, status, error } = useInterventionsBatchAssign(ids);

  const onMutateReady = (values: UsersSelectOptionItem[]) => {
    const users = values.map(({ value }) => value);
    return mutate(users);
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
